module.exports = {
}


// WEBPACK FOOTER //
// ./src/pages/forget/i18n/locale.zh-cn.js